import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/A2';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得先前繳別變更記錄
export function getInfoA2() {
    return get(`${url}/info`);
}

/**
 * sumbit
 * @param {Object} data
 */
export function submitA2(data) {
    return post(`${url}/submit`, { defer: data }, { ...options, repeatRequestCancel: true });
}
